import { axiosGet, axiosPost, axiosPut, axiosDelete } from "../options/header"

//poziv express-u da dohvati podatke vezane uz osobu
export default {
  logUserLogin(id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/login-user", {
        params: {
          user_id: id,
        },
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getUsers() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/users", {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  changeUserRole(user_id, new_role, token) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/users/" + user_id, {
        params: {
          token: token,
          new_role
        },
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getBulletinBoard() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/bulletin-board", {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getBulletinBoardValid() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/bulletin-board/valid", {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  createBulletinNotification(formData) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/bulletin-board", formData, {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  editBulletinNotification(formData) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/bulletin-board", formData, {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getOglasnaAttachent(accessToken, attach_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/bulletin-board/attachment/" + attach_id, {
        params: {
          
        },
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  deleteBulletinNotification(notification_id, privici, token) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/bulletin-board/delete-oglas/" + notification_id,
        {
          params: {
            privici: privici,
            token: token,
          },
           credentials: true
        });
    } catch (err) {
      console.log(err);
    }
  },
  getOrganizationInfo() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/organization-info", {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getDesktopApplication() {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/desktop-download", {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  saveTroskovnikReport(troskovnik_report_data) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/troskovnik-edit-report", {
        troskovnik_report_data,
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getReleaseNotes() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/release-notes", {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  addNewReleaseNote(release_note) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/release-notes", {
        release_note,
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  editReleaseNote(release_note) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/release-notes", {
        release_note,
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  deleteReleaseNote(release_uid) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/admin/release-notes/" + release_uid,{
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
}

